import type { ReactionDuelView } from '@minigame-race/contracts';
import type { MinigameProps } from '../../race/types.js';
import { ReactionDuelBoard } from '../../turn/ReactionDuelBoard.js';
import { TurnBoardFrame } from '../../turn/TurnBoardFrame.js';

/** Reaction Duel as a race segment. See ConnectFourGame for the turn-adapter note. */
export function ReactionDuelGame({ view, emit }: MinigameProps) {
  const v = view as ReactionDuelView | null;
  if (!v) return null;
  return (
    <TurnBoardFrame>
      <ReactionDuelBoard view={v} onMove={emit} />
    </TurnBoardFrame>
  );
}
